
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import HomeBG from '../../resources/homeBgIm.png';

import SpeciaLogo2 from '../../resources/circle specia 2.png';

import SpeciaLogo from '../../resources/speciaLogo.png';

import SecurityImg from '../../resources/Security.png';

import SpeciaLogoWithName from '../../resources/SpeciaLogoWithName.png';

import BGD from '../../resources/BGD1.png';

import TeamLogo from '../../resources/chart.png';

import PlayButton from '../../resources/playbutton.png';

import Cookies from 'universal-cookie';

import { Form } from 'react-bootstrap';
import { ButtonBase, Button } from '@mui/material';

import MailOutlineIcon from '@mui/icons-material/MailOutline';

import LocationOnIcon from '@mui/icons-material/LocationOn';

export default () => {
  const navigate = useNavigate();

  const auth = useAuth();

  const [
    searchParams,
    setSearchParams,
  ] = useSearchParams();
  const token = searchParams.get('token');

  const [
    status,
    setStatus,
  ] = useState(200);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    name,
    setName,
  ] = useState('');
  const [
    email,
    setEmail,
  ] = useState('');
  const [
    phoneNumber,
    setPhoneNumber,
  ] = useState('');

  const cookies = new Cookies();

  const currentPath = cookies.get('currentPath') || '/';

  useEffect(() => {
    if (auth.isAuthenticated) {
      console.log(currentPath);
      navigate(currentPath);
    }

    if (token) {
      const urlWithToken = new URL(`${window.origin}/api/microsoft/subscription/new`);
      urlWithToken.searchParams.set('token', token);
      setLoading(true);
      fetch(urlWithToken.toString(), {
        method: 'GET',
      }).then((response) => {
        setStatus(response.status);
        setLoading(false);
      }).catch((error) => {
        console.error(error);
      });
    }
  }, [auth.isAuthenticated]);

  var w = window.innerWidth;
  var h = window.innerHeight;
  if (w > h) {
    return (
      <>

        <div style={{ display: 'flex', flexDirection: 'column', width: '100vw', padding: '0', textAlign: 'center', alignItems: 'center', padding: '0 8vw' }}>

          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '80vh', marginBottom: '0', color: 'rgb(0, 0, 0, 0.8)' }}>
            <div style={{ height: '80vh', width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'left', textAlign: 'left', flex: 1, marginLeft: '3vw' }}>
                <p style={{ fontSize: '1.5vw', fontWeight: '400', letterSpacing: '0.05vw' }}>Contact us</p>
                <p style={{ fontWeight: '400', fontSize: '2.5vw', width: '47vw', marginTop: '0.5vw', lineHeight: '1.8vw', letterSpacing: '0.05vw' }}>
                  Get in touch
                </p>
                <p style={{ fontWeight: '300', fontSize: '0.9vw', width: '40vw', marginTop: '1vw', lineHeight: '1.8vw' }}>
                  We will get back to you within 24 hours, or call us anytime
                </p>
                <p style={{ fontWeight: '300', fontSize: '1.1vw', width: '40vw', marginTop: '3vw', lineHeight: '1.8vw', letterSpacing: '0.07vw' }}>
                  <MailOutlineIcon style={{ marginRight: '1vw' }} />
                  {' '}
                  support@specia.ai
                </p>
                <p style={{ fontWeight: '300', fontSize: '1.1vw', width: '40vw', marginTop: '1vw', lineHeight: '1.8vw', letterSpacing: '0.07vw' }}>
                  <LocationOnIcon style={{ marginRight: '1vw' }} />
                  {' '}
                  350 Little Collins Street, Melbourne, VIC 3000
                </p>
                {/* <div style={{width: '55vw', height: '30vw', background: 'rgb(0, 0, 0, 0.5)', borderRadius: '1vw', marginTop: '3.5vw', backgroundImage: "url('https://specia.ai/wp-content/uploads/2021/11/campaign-creators-e6n7uoEnYbA-unsplash-1.jpg')", backgroundSize: '100%'}}>
                                    <div style={{width: '100%', height: '100%', backgroundColor: 'rgb(0, 0, 0, 0.6)', borderRadius: '1vw', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                                        <img src={PlayButton} style={{filter: "invert(1)", width: '5vw', height: '5vw'}}/>
                                    </div>
                                </div> */}
              </div>
              <div style={{ marginTop: '0vw', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 2, marginRight: '3vw' }}>
                <div style={{ flex: 1, backgroundColor: 'rgb(255, 255, 255, 0.0)', width: '100%', padding: '2vw' }}>
                  <h4 style={{ textAlign: 'left', fontSize: '1.5vw', marginBottom: '2vw', fontWeight: '500' }}>Send a message</h4>

                  <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.9vw', padding: '0', textAlign: 'left' }}>Send us a message and we will get back to you within 24 hours.</p>

                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left', marginRight: '1.5vw' }}>
                      {/* <p style={{fontSize: '0.9vw', marginBottom: '0.5vw', marginLeft: '0.2vw'}}>Name</p> */}
                      <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(255,255,255,.5)', backdropFilter: 'blur(50px)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
                    </Form.Group>
                    <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
                      {/* <p style={{fontSize: '0.9vw', marginBottom: '0.5vw', marginLeft: '0.2vw'}}>Email Address</p> */}
                      <Form.Control autocomplete="new-password" style={{ height: '3vw', backgroundColor: 'rgba(255,255,255,.5)', backdropFilter: 'blur(50px)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Email Address" value={email} onChange={e => setEmail(e.target.value)} />
                    </Form.Group>
                  </div>

                  <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
                    {/* <p style={{fontSize: '0.9vw', marginBottom: '0.5vw', marginLeft: '0.2vw'}}>Message</p> */}
                    <Form.Control as="textarea" style={{ resize: 'none', height: '9vw', backgroundColor: 'rgba(255,255,255,.5)', backdropFilter: 'blur(30px)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw', paddingTop: '0.8vw' }} placeholder="Message" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
                  </Form.Group>
                  <Button
                    variant="outlined"
                    style={{ flex: 1, marginRight: '1vw', marginTop: '1.5vw', marginBottom: '2vw',
                      borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.8vw 1.2vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#39887F, #39887F)', borderRadius: '0.4vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.06vw',
                      width: '100%', marginTop: '0vw' }}
                  >
                    Send Message
                  </Button>

                  {/* <Button variant="outlined" style={{
                                        borderColor: 'rgb(255, 255, 255, 1)', padding: '0.9vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#f25252, #f25252)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.08vw'
                                    , width: '100%', marginTop: '0vw'}}>Send Message</Button> */}
                </div>

              </div>
            </div>
          </div>

        </div>

      </>
    );
  }
};

